import { handleActions } from "redux-actions"
import produce from "immer"
import lodash from "lodash"
import { toast } from "react-toastify"

import {
  REQUEST_ADD,
  RECEIVE_ADD,
  REQUEST,
  RECEIVE,
  SAVE_UI,
  SET_FILTER,
  APPLY_FILTER,
  SET_CURRENT_FILTER
} from "./constants"

const initFilter = {
  searchType: "fulltext",
  search: "",
  country: lodash.get(global.currentCustomer, "postaladdress.country", ""),
  usePickupAddress: true,
  useDeliveryAddress: true
}

const initialState = {
  add: {
    isLoading: false,
    error: undefined,
    result: undefined
  },
  itemsById: {},
  itemsByIndex: {},
  totalCount: 0,
  loadedPages: {},
  filter: initFilter,
  filterForm: initFilter,
  initFilter,
  isLoading: false,
  ui: {
    currentRow: 0,
    isDetailOpen: false
  },
  currentFilter: initFilter
}

const handleRequestAdd = produce(draft => {
  draft.add.isLoading = true
  draft.add.result = undefined
  draft.add.error = undefined
})

const handleReceiveAdd = produce((draft, { payload: { result, error } }) => {
  draft.add.isLoading = false
  draft.add.result = result
  draft.add.error = error
})

const handleSaveUi = produce(
  (draft, { payload: { currentRow, isDetailOpen } }) => {
    if (isDetailOpen !== undefined)  {
      draft.ui.isDetailOpen = isDetailOpen
    }
    if (currentRow || currentRow === 0) {
      draft.ui.currentRow = currentRow
    }
  }
)

const handleSetFilter = produce((draft, { payload: values }) => {
  lodash.forOwn(values, (value, key) => (draft.filterForm[key] = value))
})

const handleApplyFilter = produce((draft, { payload }) => {
  draft.isLoading = true
  draft.filter = lodash.cloneDeep(draft.filterForm)
  draft.itemsById = {}
  draft.itemsByIndex = {}
  draft.loadedPages = {}
  draft.totalCount = 0
})

const handleRequest = produce(
  (draft, { payload: { startIndex, stopIndex } }) => {
    // nullify loading entries
    for (let i = startIndex; i <= stopIndex; i++) {
      draft.itemsByIndex[i] = null
    }
  }
)

const handleReceive = produce(
  (
    draft,
    {
      payload: {
        result: { itemsById, itemsByIndex, page, totalCount } = {},
        error
      },
      payload
    }
  ) => {
    if (error) {
      toast.error(
        "Abruf des Adressbuches fehlgeschlagen! Bitte erneut versuchen."
      )
      draft.isLoading = false
      return
    }
    lodash.forOwn(itemsById, (value, key, object) => {
      draft.itemsById[key] = value
    })
    lodash.forOwn(itemsByIndex, (value, key, object) => {
      draft.itemsByIndex[key] = value
    })
    draft.loadedPages[page] = true
    draft.totalCount = totalCount
    draft.isLoading = false
  }
)

const handleSetCurrentFilter = produce((draft, { payload }) => {
  draft.currentFilter = payload
})

export default handleActions(
  {
    [REQUEST_ADD]: handleRequestAdd,
    [RECEIVE_ADD]: handleReceiveAdd,
    [SET_FILTER]: handleSetFilter,
    [APPLY_FILTER]: handleApplyFilter,
    [SAVE_UI]: handleSaveUi,
    [REQUEST]: handleRequest,
    [RECEIVE]: handleReceive,
    [SET_CURRENT_FILTER]: handleSetCurrentFilter
  },
  initialState
)
